const galleryId = 103;

const items = [];

let id = galleryId * 1000;

function addItemToGroup(item, tag) {
    id++;
    items.push({
        "id": id,
        "title": { "en": "" },
        "src": item,
        "tags": [tag],
        "groups": [galleryId],
        "ordering": id,
    });
}
let group = [];

group = ["sh_1449683246.jpg","sh_1486979432.jpg","sh_1502972330.jpg","sh_1542434750.jpg","sh_1741122356.jpg"];
group.forEach((i) => addItemToGroup(i, '1. Caries'));

group = ["sh_1710200206.jpg","sh_1211429056.jpg","sh_1444882397.jpg","sh_120050842.jpg","sh_1086143969.jpg","sh_1396865294.jpg"];
group.forEach((i) => addItemToGroup(i, '2. Broken tooth'));

group = ["sh_1382843888.jpg","sh_1647109045.jpg","sh_1382843879.jpg","sh_1702192570.jpg","sh_4416745.jpg","sh_577643599.jpg","sh_1498595660.jpg","sh_1729800100.jpg","sh_1852850374.jpg"];
group.forEach((i) => addItemToGroup(i, '3. Bruxism'));

group = ["sh_1248434191.jpg"];
group.forEach((i) => addItemToGroup(i, '4. Enamel wear'));

group = ["sh_1301155513.jpg","sh_745659544.jpg","sh_1682124145.jpg","sh_1824108014.jpg"];
group.forEach((i) => addItemToGroup(i, 'Before-after'));

group = ["sh_1234819225a.jpg","sh_504131488a.jpg","sh_560464690a.jpg","sh_1626317917.jpg","sh_1626317914.jpg","sh_1626317932.jpg","sh_1115806589.jpg","sh_1234819225a.jpg","sh_1442460674.jpg","sh_343666856.jpg"];
group.forEach((i) => addItemToGroup(i, 'x_new_dental_problems'));

export default items;
